import prop from 'ramda/src/prop'
import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector'

export default (state, props) => prop('landingShortUrl', getRecordSelector(state, props))
